<template>
  <hm-content title="">
    <div>
      <el-button type="primary" size="small" @click="addShareGroup"
      >添加分组</el-button
      >
    </div>
    <div class="table-panel flex  flex-end">
      <el-input
          clearable
          style="width:300px"
          v-model.trim="searchCondition.groupName"
          :placeholder="placeholder"
          size="small"
          class="ipt mr10"
      >
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
      >重置</el-button
      >
    </div>

    <div class="table">
      <el-table
          stripe
          border
          ref="table"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
      >
        <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="分组名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="createBy"
            label="创建人"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
        >
        </el-table-column>
        <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="300"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="remove(scope.row)"
              >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
        title="新增分组"
        :close-on-click-modal="false"
        :visible.sync="addGroupVisible"
        width="800px"
        @close="resetForm('groupForm')"
    >
      <el-form
          :model="groupForm"
          :rules="groupRule"
          ref="ruleForm"
          label-width="100px"
          class="large-label-form"
      >
        <el-form-item label="分组名称：" prop="groupName">
          <el-input
              size="small"
              clearable
              v-model.trim="groupForm.groupName"
          ></el-input>
        </el-form-item>

      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="addGroupVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      detailsType: "",
      title: "",
      type: "share",
      currentPageDetails: 1,
      pageSizeDetails: 10,
      detailsTotal: 0,
      detailsBill: [],
      dialogVisible: false,
      isOutputing: false,
      addGroupVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      placeholder: "请输入分组名称",
      searchCondition: {
        queryType: "memberMobile",
        personType: "",
        groupName: ""
      },
      groupForm: {
        groupName: ""
      },
      groupRule: {

      },
      searchConditionBill: {},
      row: {},
      shareCenterId: "",
      personal: {
        dueDate: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async edit() {
      if (this.personal.dueDate !== "") {
        const { code } = await this.$store.dispatch(
            "changeShareMemberDueDate",
            {
              shareCenterId: this.shareCenterId,
              dueDate: this.personal.dueDate
            }
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.queryDetailsList();
        }
      } else {
        this.$message({
          message: "请选择到期日期",
          type: "warning"
        });
      }
    },
    toLowerLv(row) {
      this.$router.push({
        name: "LowerLevelAgent",
        query: {
          row: JSON.stringify(row),
          sendCommissionMode: "oneself"
        }
      });
    },
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        sendCommissionMode: "oneself"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "shareGroupList",
          params
      );
      const { records, total } = result;
      this.list = records;
      console.log(this.list)
      this.total = total;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },

    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },


    pagingDetails(page) {
      this.currentPageDetails = page;
      this.queryDetailsList();
    },
    handleSizeChangeDetails(size) {
      this.currentPageDetails = 1;
      this.pageSizeDetails = size;
      this.queryDetailsList();
    },
    searchBill() {
      this.currentPageDetails = 1;
      this.queryDetailsList();
    },
    switchTab(val) {
      this.currentPageDetails = 1;
      this.queryDetailsList();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    addShareGroup() {
      this.addGroupVisible = true;
    },
    save() {
      const params = JSON.parse(JSON.stringify(this.groupForm));
      console.log(params)
      this.$store.dispatch(
          "addShareGroup",
          params
      ).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.addGroupVisible = false;
          this.queryList();
          setTimeout(() => {
            this.resetForm();
          }, 0);
        }
      });
    },
    remove(row) {
      const params = row;
      this.$store.dispatch(
          "deleteShareGroup",
          params
      ).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    resetForm(formName) {
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.addGroupVisible = false;
    },
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 15px;
    }
  }
}
.empty {
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
  .empty_tex {
    font-size: 18px;
    color: #666666;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding: 0;
  }
}
</style>
